import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { LanguageCodeEnumValues } from '@/services/ws-companies/src/main/resources/rest-api/constants';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button, DropdownList, Icons } from '@/js/libs/ui/src/V2';

import { LanguageTitle } from './styled';

type LanguageDropdownProps = {
  languages?: string[];
};

export const LanguageDropdown = memo(function LanguageDropdown({ languages = LanguageCodeEnumValues }: LanguageDropdownProps) {
  const [t, i18n] = useTranslation(['common']);

  const lowercased = languages.map((code) => code.toLowerCase());

  const onChangeLanguage = useCallbackRef((key: string) => i18n.changeLanguage(key));

  return (
    <DropdownList
      minWidth={false}
      dataTestId='language-button'
      renderButton={() => (
        <Button iconOnly ghost title={t('common:LANGUAGE')}>
          <Icons.Globe size={20} />
        </Button>
      )}>
      {lowercased.map((language) => (
        <DropdownList.DropdownItem
          key={language}
          onClick={() => onChangeLanguage(language)}
          dataTestId={`language-list-item-${language}`}
          isSelected={language === i18n.language}>
          <LanguageTitle>{language}</LanguageTitle>
        </DropdownList.DropdownItem>
      ))}
    </DropdownList>
  );
});
